import * as Analyze from '@appStore/analyze/actions/analyze.actions';

export * from '@appStore/analyze/actions/analyze.actions';

export const ActionTypes = {
  ...Analyze.AnalyzeActionTypes
};

export type Actions = Analyze.AnalyzeActions;
